import axios from "axios";

import { API_URL } from "shared/config/properties";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config: any) => {
  if (config) {
    return {
      ...config,
      // headers: {
      //   ...config.headers,
      //   Authorization: `Bearer ${""}`,
      // },
    };
  }

  return config;
});

axiosInstance.interceptors.response.use(undefined, (error) => {
  return error.response;
});

export default axiosInstance;
